import React from 'react'

interface Props {
  imgUrl: string
  progress: number
  size?: number
  strokeWidth?: number
  uniqueIdentifier: number
}

export const PhotoProgressBar: React.FC<Props> = ({
  imgUrl,
  progress,
  size = 56,
  strokeWidth = 3,
  uniqueIdentifier,
}) => {
  const radius = (size - strokeWidth) / 2
  const viewBox = `0 0 ${String(size)} ${String(size)}`

  const strokeDasharray = radius * Math.PI * 2
  const strokeDashoffset = strokeDasharray - (strokeDasharray * progress) / 100

  const halfSize = size / 2

  return (
    <svg width={size} height={size} viewBox={viewBox}>
      <defs>
        <pattern
          id={`progress_image_${String(uniqueIdentifier)}`}
          x={-size / 2}
          y={-size / 2}
          patternUnits="userSpaceOnUse"
          height={size}
          width={size}
        >
          <image
            x="0"
            y="0"
            height={size}
            width={size}
            xlinkHref={imgUrl}
            preserveAspectRatio="xMidYMid slice"
          />
        </pattern>
      </defs>
      <circle
        r={halfSize - 2 * strokeWidth}
        fill={`url(#progress_image_${String(uniqueIdentifier)})`}
        transform={`translate(${String(halfSize)}, ${String(halfSize)})`}
      />
      <circle
        className="circle-background"
        cx={halfSize}
        cy={halfSize}
        r={radius}
        strokeWidth={`${String(strokeWidth)}px`}
        fill="transparent"
        stroke="#e8e8e8"
      />
      <circle
        className="circle-progress"
        cx={halfSize}
        cy={halfSize}
        r={radius}
        strokeWidth={`${String(strokeWidth)}px`}
        // Start progress marker at 12 O'Clock
        transform={`rotate(-90 ${String(halfSize)} ${String(halfSize)})`}
        strokeDasharray={strokeDasharray}
        strokeDashoffset={strokeDashoffset}
        fill="transparent"
        stroke="#24b7fc"
      />
    </svg>
  )
}
